import { useCallback, useState } from 'react'
import { parseCookies } from 'nookies'

import { validateReservation } from 'features/space/services/reservationValidateApi'
import type { ReservationQuoteParams } from 'features/space/types/reservation'

export const useValidateReservation = () => {
  const cookies = parseCookies()
  const [isValidating, setValidating] = useState(false)

  const validate = useCallback(
    async (params: ReservationQuoteParams) => {
      setValidating(true)

      const result = await validateReservation(params, cookies.jwt_token)

      setValidating(false)

      if (result.valid) {
        return { valid: true as const }
      }

      if (!result.errors) {
        return { valid: false as const, errorMessages: null }
      }

      const errorMessages = Object.keys(result.errors).map((errorKey) => result.errors[errorKey][0])

      return { valid: false as const, errorMessages }
    },
    [cookies.jwt_token]
  )

  return { validate, isValidating }
}
